module.exports = __webpack_public_path__ + "img/copper.7492ed10.png";